import { ErrorHandler, Injectable, inject } from '@angular/core';
import { getError } from './sentry.helpers';
import { SentryService } from './sentry.service';

export const CHUNK_LOAD_ERROR_KEYWORD = 'ChunkLoadError';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  private readonly sentryService = inject(SentryService);

  handleError(unkownError: unknown) {
    const error = getError(getOriginalError(unkownError));

    if (isChunkLoadError(error)) {
      // chunk-load-error is now handled in router-effects, as such we can now emit it as only a warning
      return this.sentryService.captureWarning(error);
    }
    return this.sentryService.captureException(error);
  }
}

export const isChunkLoadError = (error: Error | null | undefined): boolean =>
  !!error?.name?.includes(CHUNK_LOAD_ERROR_KEYWORD);

// not sure if originalError is still necessary
const getOriginalError = (error: unknown): unknown =>
  hasOriginalError(error) ? error.originalError : error;
const hasOriginalError = (error: unknown): error is { originalError: unknown } =>
  !!(error as { originalError: unknown })?.originalError;
